import styled, { css } from "styled-components";

export interface NameViewParams {
	columnNum: number;
}

export const NameView = styled.p.withConfig({
	shouldForwardProp: (prop) => !["columnNum"].includes(prop),
})<NameViewParams>`
	line-height: 19px;
	color: #333;
	font-size: 14px;
	font-weight: 400;
	word-break: break-all;
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	margin: 0;
	font-family: var(--fontMedium);

	${(props: NameViewParams) => {
		return css`
			-webkit-line-clamp: ${props.columnNum};
		`;
	}}

	&:hover {
		color: var(--hoverFontColor);
	}
	.titleTag {
		width: 18px;
		height: 12px;
		margin-right: 3px;
	}
`;
